import * as React from 'react';
import ChartAverageInterface from '@app/Interface/Chart/ChartAverageInterface';
import moment from 'moment';
import TabulatorReferenceInterface from '@app/Interface/TabulatorReferenceInterface';
import DownloadIcon from '@patternfly/react-icons/dist/js/icons/download-icon';
import { Button } from '@patternfly/react-core';

import SCTabulator from '@app/utils/SCTabulator';
import options from '@app/utils/SCTabulatorCommonOptions';
import TabulatorAccessors from '@app/utils/TabulatorAccessors';

interface ChartHistoryTableProps {
    data: ChartAverageInterface[];
    downloadFilename: string;
}

const ChartHistoryTable: React.FC<ChartHistoryTableProps> = ({data, downloadFilename, children}) => {
    // In order to get tabulator to work with moment-timezone
    // we need to add moment to the global namespace.
    // see: https://stackoverflow.com/a/54135475/8038146
    window.moment = moment;

    const [historyRef, setHistoryRef] = React.useState<React.MutableRefObject<null>|null>(null);

    const historyRefCallback = React.useCallback(node => {
        setHistoryRef({current: node});
    }, []);

    const downloadReportCSV = () => {
        if (historyRef?.current) {
            const tabulator: TabulatorReferenceInterface = historyRef.current;
            tabulator.table.download('csv', downloadFilename);
        } else {
            console.log('Unable to download chart CSV');
        }
    };

    const tabulatorColumns = [
        { title: 'Date', field: 'date', formatter: 'datetime', formatterParams: {
            outputFormat: 'MMM YY',
        }, headerSort: false, accessorDownload: TabulatorAccessors.nullValueDownloadAccessor },
        { title: 'Producer', field: 'producerValue', formatter: 'money', formatterParams: {
            precision: 2
        }, headerSort: false, accessorDownload: TabulatorAccessors.nullValueDownloadAccessor },
        { title: 'NDA', field: 'ndaValue', formatter: 'money', formatterParams: {
            precision: 2
        }, headerSort: false, accessorDownload: TabulatorAccessors.nullValueDownloadAccessor },
    ];
    
    return (
        <>
            <Button className="pf-u-float-right" icon={<DownloadIcon/>} onClick={downloadReportCSV}>
                Download CSV
            </Button>
            <SCTabulator
                tableRef={historyRefCallback}
                data={data}
                columns={tabulatorColumns}
                layout="fitColumns"
                options={{
                    ...options('nda-history-table-sc', false, false)
                }}
            />
        </>
    );
}

export default ChartHistoryTable;